import { styled as t } from "styled-components";
import { Small as i } from "../../../styles/typography/index.js";
import { MediaQuery as e } from "../../../styles/variables.js";
const m = t.ul`
  max-height: 100vh;
  overflow-y: auto;
  height: 100%;
  margin-top: 2px;

  @media ${e.SCREEN_MD_UP} {
    max-height: 360px;
  }
`, n = t.div`
  ${i}
  height: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
`;
export {
  m as NotificationBarListContainer,
  n as NotificationBarListEmptyState
};
